import { NgTemplateOutlet } from "@angular/common";
import { booleanAttribute, Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { DvsUtilities } from "src/app/dvs-utilities";

@Component({
	selector: "app-action-button",
	templateUrl: "./action-button.component.html",
	styleUrls: ["./action-button.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgTemplateOutlet]
})
export class ActionButtonComponent implements OnInit {
	@Input()
	action: () => Promise<any>;
	@Input()
	args: any[];
	@Input()
	context: any;
	@Input()
	processing: string;
	@Input()
	complete: string;
	@Input()
	btnClass: string;
	@Input()
	confirm: string;
	@Input()
	disabled: boolean;
	@Input()
	submit: boolean;
	@Input({ transform: booleanAttribute })
	file: boolean = false;

	public pending = false;
	public success = false;
	public problem: string;
	public actionResult: string;

	ngOnInit(): void {
		this.submit = this.submit !== undefined && this.submit !== false;
		this.disabled = this.disabled !== undefined && this.disabled !== false;
	}

	async PerformAction(event: any = null) {
		this.problem = undefined;
		this.success = false;
		this.actionResult = undefined;
		if (this.confirm) {
			if (!confirm(this.confirm)) {
				return;
			}
		}
		try {
			this.pending = true;
			if (this.file && event) this.args = [event.target.files[0]];
			const result = await this.action.apply(this.context, this.args);
			if (result && typeof result === "string") {
				this.actionResult = result;
			}
			this.success = true;
		} catch (err) {
			this.problem = DvsUtilities.GetRemoteErrorMessage(err, "Operation failed");
			throw err;
		} finally {
			this.pending = false;
		}
	}

}
